/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterContact } from '../../models/profile-newsletter-contact';
import { ProfileNewsletterContactPatch } from '../../models/profile-newsletter-contact-patch';

export interface ProfileNewsletterPatchContact$Params {
  id: number;
  email: string;
      body: ProfileNewsletterContactPatch
}

export function profileNewsletterPatchContact(http: HttpClient, rootUrl: string, params: ProfileNewsletterPatchContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterContact>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterPatchContact.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('email', params.email, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterContact>;
    })
  );
}

profileNewsletterPatchContact.PATH = '/rest/profile/{id}/newsletter/contact/{email}';
